import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

const ChannelBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isSelected" && prop !== "isDisabled",
})(({ theme, isSelected, isDisabled }) => ({
  width: 32,
  height: 32,
  borderRadius: "6px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: theme.typography.customFontSize[0],
  fontWeight: theme.typography.customFontWeight[2],
  userSelect: "none",
  transition: "all 0.1s",
  cursor: isDisabled ? "not-allowed" : "pointer",

  ...(isDisabled && {
    backgroundColor: "#f5f5f5",
    color: "#bbb",
    border: "1px solid #e0e0e0",
  }),

  ...(isSelected && {
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
    border: `1px solid ${theme.palette.primary.main}`,
  }),

  ...(!isSelected && {
    backgroundColor: "#fff",
    color: theme.palette.primary.main,
    border: `1px solid ${theme.palette.primary.greyFifth}`,
    "&:hover": {
      border: `1px solid ${theme.palette.primary.main}`,
    },
  }),
}));

export const StyledChannelBox = ({
  value,
  isSelected = false,
  isDisabled = false,
  onClick,
}) => {

  return (
    <ChannelBox
      {...{
        isSelected,
        isDisabled,
        onClick: () => !isDisabled && onClick(value)
      }}
    >
      {value}
    </ChannelBox>
  );
};